// removed by extract-text-webpack-plugin
module.exports = {"this":"GroupOrgList-GroupItem__this___15SpF","withUnreads":"GroupOrgList-GroupItem__withUnreads___3QRu1","container":"GroupOrgList-GroupItem__container___1r4s9","avatar":"GroupOrgList-GroupItem__avatar___3-w7K","name":"GroupOrgList-GroupItem__name___1Yuam","badge":"GroupOrgList-GroupItem__badge___FPgwJ"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupOrgList-GroupItem.css
// module id = 2284
// module chunks = 0 1